import { render, staticRenderFns } from "./XildaAmbassador.vue?vue&type=template&id=69114ace&"
import script from "./XildaAmbassador.vue?vue&type=script&lang=js&"
export * from "./XildaAmbassador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports